import { Text, Tooltip } from '@dixa/lib-shared-habla';
import type * as Popover from '@radix-ui/react-popover';
import classnames from 'classnames';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { ConversationsChannels } from 'lib-shared-legacy-types';
import { ConversationStatus } from 'lib-shared-types-api';
import type { Channel } from 'lib-shared-types-channels';
import { memo } from 'react';

import { AppLink } from 'components/appLink';
import { ConversationChannelIcon } from 'components/conversation';
import { getChannelName } from 'utils/channels';

import styles from './conversationChip.module.scss';
import { ConversationChipPopover } from './popover/conversationChipPopover';

type ConversationChipProps = {
  csid: number;
  channel: Channel;
  status: ConversationStatus;
  popoverContentProps?: Popover.PopoverContentProps;
};

export const ConversationChip = memo(function ConversationChip({
  csid,
  channel,
  status,
  popoverContentProps,
}: ConversationChipProps): JSX.Element {
  const rootClass = classnames({
    [styles.root]: true,
    [styles.rootOpen]: status === 'open',
    [styles.rootClosed]: status === 'closed',
    [styles.rootPending]: status === 'pending' || status === 'awaitingpending',
  });

  return (
    <ConversationChipPopover csid={csid} {...popoverContentProps}>
      <AppLink
        className={rootClass}
        path="/conversation/:csid"
        params={{ path: { csid: `${csid}` } }}
        data-testid="conversation-chip"
      >
        <span className={styles.icon}>
          <Tooltip content={channel ? getChannelName(channel) : ''} wrap="none">
            <ConversationChannelIcon
              color="neutral.000"
              size={20}
              channel={
                convertChannelCasing(
                  channel,
                  'truncate',
                ) as ConversationsChannels
              }
            />
          </Tooltip>
        </span>

        <Text.Paragraph
          as="span"
          className={styles.csid}
          variant="3"
          color="inherit"
        >
          #{csid}
        </Text.Paragraph>
      </AppLink>
    </ConversationChipPopover>
  );
});
